import styled from 'styled-components'
export const Wrapper = styled.div`
  width: 100%;
  /* .small {
    display: none;
  } */
  .large {
    margin-top: 70px;
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    /* .large {
      display: none;
      margin-top: 0px;
    }
    .small {
      display: flex;
      width: 100%;
      margin-top: 30px;
    } */
  }
  .swiper-wrapper {
  }
  .general {
    background-color: ${({ theme }) => theme.colors.moneyInterestCard};
  }

  .target {
    background-color: ${({ theme }) => theme.colors.stillSellingBg};
  }

  .emergency {
    background-color: ${({ theme }) => theme.colors.emergencyColorTwo};
  }
  .savings-title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: ${({ theme }) => theme.colors.black};
  }
  .item-height {
    width: 80%;
    height: 200px;
    background-color: white;
    box-shadow: 10px 0px 0px rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    display: flex;
    padding: 20px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin-right: 20px;
  }
  .paragraph {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.CardDark};
    mix-blend-mode: normal;
  }

  .paragraph {
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x7};
    line-height: 21px;
    letter-spacing: -0.137846px;
    color: ${({ theme }) => theme.colors.gray};
    margin-top: -15px;
  }
  .cardinfo {
    margin-top: -15px;
  }
  .title {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: flex;
      align-items: center;
    }
    & img {
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        width: 20px;
      }
    }
  }
  .saving-link {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    }
    @media (max-width: 350px) {
    }
  }
`
export const SavingTypesWrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* flex-wrap: wrap; */
  margin-top: 40px;
  margin-right: -32px;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
    flex-wrap: wrap;
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    margin-right: 0px;
    width: 100%;
    flex-direction: column;
  }

  .general {
    background-color: ${({ theme }) => theme.colors.moneyInterestCard};
  }

  .target {
    background-color: ${({ theme }) => theme.colors.stillSellingBg};
  }

  .emergency {
    background-color: ${({ theme }) => theme.colors.emergencyColorTwo};
  }
  .savings-title {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: ${({ theme }) => theme.colors.black};
  }
  .item-height {
    width: 80%;
    height: 200px;
    background-color: white;
    box-shadow: 0px 0px 60px rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    display: flex;
    padding: 20px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin-right: 20px;
    @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
      margin-right: 0px;
      width: 80%;
      margin-bottom: 30px;
    }

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-right: 0px;
      width: 90%;
      margin-bottom: 30px;
    }
  }
  .paragraph {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.CardDark};
    mix-blend-mode: normal;
  }

  .paragraph {
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x7};
    line-height: 21px;
    letter-spacing: -0.137846px;
    color: ${({ theme }) => theme.colors.gray};
    margin-top: -15px;
  }
  .cardinfo {
    margin-top: -15px;
  }
  .title {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
    }
    & img {
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        width: 50px;
      }
    }
  }
  .saving-link {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    }
    @media (max-width: 350px) {
    }
  }
`
// 56
